import './actionsColumn.less';

import { observer } from 'mobx-react';
import React from 'react';

import { GridDataEntry } from 'controls/grid/gridDataEntry';
import { GridSelection } from 'controls/grid/gridSelection';
import { GridStore } from 'controls/grid/gridStore';
import { GridMenuPlugin } from 'controls/grid/plugins/grid-menu/gridMenuPlugin';
import { AntButton } from 'controls/react/ant/antButton';

export type ActionsColumnsProps<DataEntry extends GridDataEntry> = {
	store: GridStore<DataEntry>;
};

export const HeaderActionsColumn = observer(<DataItem extends GridDataEntry>(props: ActionsColumnsProps<DataItem>) => {
	const plugin = props.store.plugins.find((x) => x.id == 'grid-menu') as GridMenuPlugin<DataItem>;

	if (!plugin.config.headerActions?.actions) {
		return null;
	}

	const gridSelection = new GridSelection(plugin.store);

	const items = plugin.getActionsForSelection(gridSelection, plugin.config.headerActions?.actions);

	return (
		<>
			{items.map((x) => {
				if ('type' in x) {
					return '';
				}
				return (
					<AntButton
						type={'text'}
						key={x.id}
						title={x.label}
						icon={x.icon}
						onClick={() => plugin.invokeAction(x, gridSelection)}
					/>
				);
			})}
		</>
	);
});
